import React, { Component } from 'react';
import { borders, oyoFormView, validation } from '../../../Enums';
import {
  hasNumber,
  hasSpecialCharacter,
  hasUpperCase
} from '../../../utils/functionUtils';
import BackIcon from '../../../resources/vectors/BackIcon';
import { centerAbs } from '../BecomeAnOyoStyles';
import { isEmptyString } from '../../../utils';

class LoginWidget extends Component {
  constructor(props) {
    super(props);
    this.logIn = this.logIn.bind(this);
    this.validatePwd = this.validatePwd.bind(this);
  }

  state = {
    username_border: borders.NORMAL_BORDER,
    password_border: borders.NORMAL_BORDER,
    password_validated: true,
    username: '',
    password: '',
    username_validated: true
  };

  changePwd = e => {
    this.setState({ password: e.target.value }, () => {
      if (!this.state.password_validated) {
        this.validatePwd();
      }
    });
  };

  logIn = () => {
    /* I am calling this function from parent because
     APIs need to be called from a place from where everything can be controlled.
     I am doing this so that I can manage the sign in and validation logic within this component
     .Also, I don't want to put the password in the reducer or props */
    let passwordValid = this.validatePwd();
    let usernameValid = this.validateUsername();

    if (passwordValid) {
      // required:  otp, phone, country_code, email, password
      let signInData = {
        country_code: this.props.globalData.locale,
        email: this.props.globalData.formData.mobile_number,
        password: this.state.password
      };
      this.props.globalActions.postLogin(signInData);
    }

    this.setState({
      password_validated: passwordValid,
      username_validated: usernameValid
    });
  };

  validateUsername = () => {
    // validate user name
    if(this.props.globalData.formData.mobile_number) return true;
    return false;
  };

  validatePwd = () => {
    let pwd = this.state.password;
    let message;
    if (isEmptyString(pwd)) message = this.props.gc('please_enter_password');

    if (message) {
      this.setState({ password_validated: false });
      this.props.globalActions.errorLogin({ message });
      return false;
    }

    this.setState({
      password_validated: true
    });
    this.props.globalActions.errorLogin('');
    return true;
  };

  componentDidMount() {
    this.props.setLoginFunction(this.logIn);
  }
  handleKeyDown = e => {
    if(e.keyCode === 13)
      this.props.handleGreenButtonOnClick();
  }
  render() {
    let gs = this.props.gs;
    let guc = this.props.guc;
    let gc = this.props.gc;
    return (
      <div>
        <div>
          <BackIcon className={'hover'} onClick={() => {
            this.props.changeFormScreen(oyoFormView.checkEarnings);
          }} style={gs('back')}/>
          <div style={gs('big_text_form')}>
            {gc('login_to_manage')}
          </div>
          {this.props.successful_sign_up && isEmptyString(this.props.globalData.loginData.errorMessage) &&
          <div style={gs('suucessful_sign_up')}>
            {gc('successfully_signed_up')}
          </div>}
          <div
              onClick={() => {
                this.props.changeFormScreen(oyoFormView.loginWithOtpStepOne);
              }}
              style={{
                ...gs('big_white_button'),
                position: 'relative',
                marginTop: '18px'
              }}
          >
              <div style={{ ...centerAbs, width: '100%' }}>
                {gc('login_with_otp')}
              </div>
          </div>
          <div style={gs('or')}>
            {'--------- '}{gc('OR')}{' ----------'}
          </div>
          <div style={gs('location_container')}>
            <div style={{...gs('form_small_text'),marginTop:'4px'}}>
              {gc('registered_mobile_number')}{'*'}
            </div>
            <input
              placeholder={''}
              type="number"
              autoComplete="new-password"
              onChange={e => {
                this.props.globalActions.dataUpdate('mobile_number', e.target.value);
              }}
              value={this.props.globalData.formData.mobile_number}
              className={'removeFocusOutline'}
              style={{
                ...gs('input_form'),
                border: this.state.username_validated
                  ? this.state.username_border
                  : borders.RED_BORDER
              }}
              onFocus={() => {
                this.setState({
                  username_border: borders.ACTIVE_BORDER
                });
              }}
              onBlur={() => {
                this.setState({
                  username_border: borders.NORMAL_BORDER
                });
              }}
            />

            <div style={gs('form_small_text')}>{gc('Password')}{'*'}</div>
            <input
              placeholder={''}
              type="password"
              autoComplete="new-password"
              onChange={this.changePwd}
              value={this.state.password}
              className={'removeFocusOutline'}
              style={{
                ...gs('input_form'),
                border: this.state.password_validated
                  ? this.state.password_border
                  : borders.RED_BORDER
              }}
              onFocus={() => {
                this.setState({
                  password_border: borders.ACTIVE_BORDER
                });
              }}
              onBlur={() => {
                this.setState({
                  password_border: borders.NORMAL_BORDER
                });
              }}
              onKeyDown={this.handleKeyDown}
            />
          </div>
        </div>
        {this.props.globalData.loginData.errorMessage && (
          <div
            style={{ ...gs('form_small_text'), color: 'red', lineHeight: '1',marginTop:'3px' }}
          >
            {this.props.globalData.loginData.errorMessage}
          </div>
        )}
      </div>
    );
  }
}

export default LoginWidget;
